// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-SSOIntegrationSetup-styles___ssoIntegrationSetupCard--bGbRs {
  margin: 16px;
  padding: 16px;
  position: relative;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.components-SSOIntegrationSetup-styles___ssoIntegrationSetupCard--bGbRs .components-SSOIntegrationSetup-styles___header--Vn8lx {
  padding: 8px 16px;
}

.components-SSOIntegrationSetup-styles___description--xepm9 {
  margin-bottom: 16px;
}

.components-SSOIntegrationSetup-styles___toggle--fNB6f {
  display: block;
  margin: 12px 0;
}

.components-SSOIntegrationSetup-styles___buttonContainer--tIAIz {
  display: flex;
  justify-content: center;
  margin-top: 32px;
}

.components-SSOIntegrationSetup-styles___integrationList--zY7_o {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0 -8px 24px;
  padding: 0 8px 8px;
  border-bottom: 1px solid #d9dee7;
}

.components-SSOIntegrationSetup-styles___integrationListTitle--a_i11 {
  flex: 0 0 100%;
  color: #4b5563;
  font-size: 0.85rem;
  font-weight: 700;
  white-space: nowrap;
}

.components-SSOIntegrationSetup-styles___integrationListItem--TPp0c {
  flex: 0 0 auto;
  text-transform: none;
  white-space: nowrap;
}

.components-SSOIntegrationSetup-styles___integrationListItem--TPp0c.MuiButton-outlined {
    color: #374151;
    border-color: #c7ced9;
  }

.components-SSOIntegrationSetup-styles___addIntegrationButton--5RbGy {
  flex: 0 0 auto;
  border-style: dashed;
  text-transform: none;
  white-space: nowrap;
}

/* SSOUploadUSB Form Styles */

.components-SSOIntegrationSetup-styles___formPaper--uIuSV {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 2rem;
  background-color: #fafafa;
}

.components-SSOIntegrationSetup-styles___formStack--KCvQo {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.components-SSOIntegrationSetup-styles___gridContainer--NiLt9 {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  align-items: flex-start;
}

@media (min-width: 600px) {

.components-SSOIntegrationSetup-styles___gridContainer--NiLt9 {
    grid-template-columns: 1fr 1fr
}
  }

.components-SSOIntegrationSetup-styles___certificateField--vq7m0 {
  grid-column: 1 / -1;
}

.components-SSOIntegrationSetup-styles___certificateField--vq7m0 .components-SSOIntegrationSetup-styles___MuiOutlinedInput-root--ItWkK {
    height: auto !important;
    align-items: flex-start;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

.components-SSOIntegrationSetup-styles___certificateField--vq7m0 .components-SSOIntegrationSetup-styles___MuiOutlinedInput-root--ItWkK fieldset {
      border-color: rgba(0, 0, 0, 0.23);
    }

.components-SSOIntegrationSetup-styles___certificateField--vq7m0 .components-SSOIntegrationSetup-styles___MuiOutlinedInput-root--ItWkK:hover fieldset {
      border-color: rgba(0, 0, 0, 0.87);
    }

.components-SSOIntegrationSetup-styles___certificateField--vq7m0 .components-SSOIntegrationSetup-styles___MuiOutlinedInput-root--ItWkK.components-SSOIntegrationSetup-styles___Mui-focused--lJoLY fieldset {
      border-color: #1976d2;
      border-width: 2px;
    }

.components-SSOIntegrationSetup-styles___certificateField--vq7m0 .components-SSOIntegrationSetup-styles___MuiOutlinedInput-input--qLWXl {
    height: 300px !important;
    overflow-y: auto !important;
    word-break: break-word;
    white-space: pre-wrap;
    font-family: monospace;
    font-size: 0.875rem;
    box-sizing: border-box;
  }

.components-SSOIntegrationSetup-styles___sectionDivider--OygIK {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #ddd;
}

.components-SSOIntegrationSetup-styles___sectionTitle--Y5VaZ {
  margin-top: 0;
  margin-bottom: 1rem;
  font-size: 1.1rem;
  font-weight: 600;
}

.components-SSOIntegrationSetup-styles___fieldLabelRequired--OyQm7 {
  margin-bottom: 0.5rem;
  font-weight: 600;
  display: flex;
  gap: 0.5rem;
}

.components-SSOIntegrationSetup-styles___requiredAsterisk--XSbA4 {
  color: #d32f2f;
  font-weight: 600;
}

.components-SSOIntegrationSetup-styles___radioGroup--YWoki {
  display: flex;
  gap: 1rem;
}

.components-SSOIntegrationSetup-styles___disabledTextField--PMZKd .components-SSOIntegrationSetup-styles___MuiOutlinedInput-root--ItWkK.components-SSOIntegrationSetup-styles___Mui-disabled--lZnEx fieldset {
      border-color: #bdbdbd;
    }

.components-SSOIntegrationSetup-styles___disabledTextFieldError--wDjAW .components-SSOIntegrationSetup-styles___MuiOutlinedInput-root--ItWkK.components-SSOIntegrationSetup-styles___Mui-disabled--lZnEx fieldset {
      border-color: #d32f2f;
    }

.components-SSOIntegrationSetup-styles___fullWidthField--GCfOe {
  width: 100%;
}

.components-SSOIntegrationSetup-styles___loginRedirectUrl--LR5xY {
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./components/SSOIntegrationSetup/styles.pcss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;AAMrB;;AAJE;IACE,cAAc;IACd,qBAAqB;EACvB;;AAGF;EACE,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,6BAA6B;;AAC7B;EACE,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,uBAAuB;AAKzB;;AAHE;;AANF;IAOI;AAEJ;EADE;;AAGF;EACE,mBAAmB;AA+BrB;;AA7BE;IACE,uBAAuB;IACvB,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;EAc3B;;AAZE;MACE,iCAAiC;IACnC;;AAEA;MACE,iCAAiC;IACnC;;AAEA;MACE,qBAAqB;MACrB,iBAAiB;IACnB;;AAGF;IACE,wBAAwB;IACxB,2BAA2B;IAC3B,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,mBAAmB;IACnB,sBAAsB;EACxB;;AAGF;EACE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAII;MACE,qBAAqB;IACvB;;AAMA;MACE,qBAAqB;IACvB;;AAIJ;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb","sourcesContent":[".ssoIntegrationSetupCard {\n  margin: 16px;\n  padding: 16px;\n  position: relative;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.ssoIntegrationSetupCard .header {\n  padding: 8px 16px;\n}\n\n.description {\n  margin-bottom: 16px;\n}\n\n.toggle {\n  display: block;\n  margin: 12px 0;\n}\n\n.buttonContainer {\n  display: flex;\n  justify-content: center;\n  margin-top: 32px;\n}\n\n.integrationList {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  margin: 0 -8px 24px;\n  padding: 0 8px 8px;\n  border-bottom: 1px solid #d9dee7;\n}\n\n.integrationListTitle {\n  flex: 0 0 100%;\n  color: #4b5563;\n  font-size: 0.85rem;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.integrationListItem {\n  flex: 0 0 auto;\n  text-transform: none;\n  white-space: nowrap;\n\n  &:global(.MuiButton-outlined) {\n    color: #374151;\n    border-color: #c7ced9;\n  }\n}\n\n.addIntegrationButton {\n  flex: 0 0 auto;\n  border-style: dashed;\n  text-transform: none;\n  white-space: nowrap;\n}\n\n/* SSOUploadUSB Form Styles */\n.formPaper {\n  border: 1px solid #ccc;\n  border-radius: 8px;\n  padding: 2rem;\n  background-color: #fafafa;\n}\n\n.formStack {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.gridContainer {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 1rem;\n  align-items: flex-start;\n\n  @media (min-width: 600px) {\n    grid-template-columns: 1fr 1fr;\n  }\n}\n\n.certificateField {\n  grid-column: 1 / -1;\n  \n  & .MuiOutlinedInput-root {\n    height: auto !important;\n    align-items: flex-start;\n    word-wrap: break-word;\n    overflow-wrap: break-word;\n    \n    & fieldset {\n      border-color: rgba(0, 0, 0, 0.23);\n    }\n    \n    &:hover fieldset {\n      border-color: rgba(0, 0, 0, 0.87);\n    }\n    \n    &.Mui-focused fieldset {\n      border-color: #1976d2;\n      border-width: 2px;\n    }\n  }\n  \n  & .MuiOutlinedInput-input {\n    height: 300px !important;\n    overflow-y: auto !important;\n    word-break: break-word;\n    white-space: pre-wrap;\n    font-family: monospace;\n    font-size: 0.875rem;\n    box-sizing: border-box;\n  }\n}\n\n.sectionDivider {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid #ddd;\n}\n\n.sectionTitle {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.fieldLabelRequired {\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  display: flex;\n  gap: 0.5rem;\n}\n\n.requiredAsterisk {\n  color: #d32f2f;\n  font-weight: 600;\n}\n\n.radioGroup {\n  display: flex;\n  gap: 1rem;\n}\n\n.disabledTextField {\n  & .MuiOutlinedInput-root.Mui-disabled {\n    & fieldset {\n      border-color: #bdbdbd;\n    }\n  }\n}\n\n.disabledTextFieldError {\n  & .MuiOutlinedInput-root.Mui-disabled {\n    & fieldset {\n      border-color: #d32f2f;\n    }\n  }\n}\n\n.fullWidthField {\n  width: 100%;\n}\n\n.loginRedirectUrl {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"ssoIntegrationSetupCard": `components-SSOIntegrationSetup-styles___ssoIntegrationSetupCard--bGbRs`,
	"header": `components-SSOIntegrationSetup-styles___header--Vn8lx`,
	"description": `components-SSOIntegrationSetup-styles___description--xepm9`,
	"toggle": `components-SSOIntegrationSetup-styles___toggle--fNB6f`,
	"buttonContainer": `components-SSOIntegrationSetup-styles___buttonContainer--tIAIz`,
	"integrationList": `components-SSOIntegrationSetup-styles___integrationList--zY7_o`,
	"integrationListTitle": `components-SSOIntegrationSetup-styles___integrationListTitle--a_i11`,
	"integrationListItem": `components-SSOIntegrationSetup-styles___integrationListItem--TPp0c`,
	"addIntegrationButton": `components-SSOIntegrationSetup-styles___addIntegrationButton--5RbGy`,
	"formPaper": `components-SSOIntegrationSetup-styles___formPaper--uIuSV`,
	"formStack": `components-SSOIntegrationSetup-styles___formStack--KCvQo`,
	"gridContainer": `components-SSOIntegrationSetup-styles___gridContainer--NiLt9`,
	"certificateField": `components-SSOIntegrationSetup-styles___certificateField--vq7m0`,
	"muiOutlinedInputRoot": `components-SSOIntegrationSetup-styles___MuiOutlinedInput-root--ItWkK`,
	"muiFocused": `components-SSOIntegrationSetup-styles___Mui-focused--lJoLY`,
	"muiOutlinedInputInput": `components-SSOIntegrationSetup-styles___MuiOutlinedInput-input--qLWXl`,
	"sectionDivider": `components-SSOIntegrationSetup-styles___sectionDivider--OygIK`,
	"sectionTitle": `components-SSOIntegrationSetup-styles___sectionTitle--Y5VaZ`,
	"fieldLabelRequired": `components-SSOIntegrationSetup-styles___fieldLabelRequired--OyQm7`,
	"requiredAsterisk": `components-SSOIntegrationSetup-styles___requiredAsterisk--XSbA4`,
	"radioGroup": `components-SSOIntegrationSetup-styles___radioGroup--YWoki`,
	"disabledTextField": `components-SSOIntegrationSetup-styles___disabledTextField--PMZKd`,
	"muiDisabled": `components-SSOIntegrationSetup-styles___Mui-disabled--lZnEx`,
	"disabledTextFieldError": `components-SSOIntegrationSetup-styles___disabledTextFieldError--wDjAW`,
	"fullWidthField": `components-SSOIntegrationSetup-styles___fullWidthField--GCfOe`,
	"loginRedirectUrl": `components-SSOIntegrationSetup-styles___loginRedirectUrl--LR5xY`
};
module.exports = ___CSS_LOADER_EXPORT___;
